export default "__VITE_ASSET__0f20d8d6__"